import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Sign_in extends PureComponent {
  render() {
    return (
      <div className="row" id="sign_in">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Authentication Sign In</h2>
              <p>
                The Authentication Sign In function returns a Session ID which
                is needed to access most other API functions. Nexoid treats User
                and API account differently. API accounts can only be used
                programmatically and will not work with the interface. They only
                return the Session ID and necessary information like system
                variables. User accounts return settings to do with the
                interface. These include default dashboard, default report, the
                interface model, time zone settings and other user interface
                settings.
              </p>
              <p>
                The most significant chunk of data returned is the interface
                model or "model". The model is a JSON object containing all the
                settings and rules for the menus object structures search rules
                and basic workflow of the Nexoid application. The model can be
                edited in the settings section of the application.
                Administrators can subscribe to pre-built models like CRM and
                ITSM. The subscribed models include the objects and basic
                functionality for those business workflows. Administrators can
                override any or all of these models at an organisation, group or
                individual user level. The Sign In function works by taking the
                subscribed model and then modifying it with ordered group
                overrides followed by ordered user overrides, giving you
                tremendous flexibility in creating different interface
                translations or different objects/interfaces for different
                groups and people in your business.
              </p>
              <p>
                For more information, look at the{" "}
                <PageLink to="/Interface#interface_overview" text="Interface" />{" "}
                section of this website. All sessions, including API accounts,
                expire after a set period of time. An administrator can set the
                expiry to either or both, absolute expiry or a rolling expiry.
                When designing API integrations, it is best practice to Sign In
                and get a new Session ID per set of work processes.
              </p>
              <p>
                To Sign In you require your Customer ID (an integer stored in a
                string) and your API URL. Both can be found in{" "}
                <PageLink to="/api#url" text="Get API URL" /> documentation. You
                will also need your username and your password.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Authentication Sign In Usage</h2>
              <p>
                This example shows an Authentication Sign In request to the API
                URL <strong>example.api.nexoid.com</strong>. The username{" "}
                <strong>Matt</strong> Customer ID <strong>8732</strong> and the
                password <strong>goldfish</strong>.{" "}
              </p>
              <p>Example Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/authentication/sign_in/
                <span className="jsonY">
                  <strong>matt</strong>
                </span>
                <div>
                  <br />
                </div>
                <div>Request Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"customer_id"</span>:{" "}
                  <span className="jsonY">"8732"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"password"</span>:{" "}
                  <span className="jsonY">"goldfish"</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Response Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "8732_wb6e0h2p9l3zsyxv46ol5njkxr8akgoc"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"default_rlp"</span>:{" "}
                  <span className="jsonY">"ICT"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"default_dashboard"</span>:{" "}
                  <span className="jsonY">"4"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"default_report"</span>:{" "}
                  <span className="jsonY">"13"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"permission"</span>: [
                  <span className="jsonY">"ADMIN"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"model"</span>: &#123; &#125;,
                </div>
                <div className="i1">
                  <span className="jsonG">"customer"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"customer_name"</span>:{" "}
                  <span className="jsonY">"ACME"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"customer_id"</span>:{" "}
                  <span className="jsonY">"8732"</span>
                </div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"interface"</span>: &#123; &#125;,
                </div>
                <div className="i1">
                  <span className="jsonG">"user"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"Matthew"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"text_username"</span>:{" "}
                  <span className="jsonY">"MATT"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"text_id"</span>:{" "}
                  <span className="jsonY">"54"</span>
                </div>
                <div className="i1">&#125;,</div>
                <div className="i1">
                  <span className="jsonG">"system_variables"</span>: &#123;
                  &#125;
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Sign_in;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Sign_in.js